import styled from "styled-components";

export const Container = styled.div`
  // background: white;
`;

export const Section = styled.div`
  margin-bottom: 24px;
`;

export const SectionTitle = styled.h3`
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const CalorieGoalContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const TitleAndInput = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const TitleText = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: #333;
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const Input = styled.input`
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 16px;
  width: 120px;
  background-color: ${(props) => (props.disabled ? "#f5f5f5" : "white")};
  color: ${(props) => (props.disabled ? "#999" : "#333")};
  &:focus {
    outline: none;
    border-color: #1976d2;
  }
`;

export const OriginalGoalText = styled.div`
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
`;

export const RestoreButton = styled.button`
  background: white;
  color: #333;
  border: 1px solid #ddd;
  border-radius: 20px;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  &:hover {
    background-color: #f5f5f5;
  }
`;

export const ViewToggle = styled.div`
  display: flex;
  justify-content: center;
  gap: 42px;
  margin-bottom: 16px;
`;

export const ToggleButton = styled.button`
  background: none;
  border: none;
  padding: 8px 0;
  font-size: 1rem;
  font-weight: 500;
  color: ${(props) => (props.active ? "##05d141" : "#666")};
  cursor: pointer;
  border-bottom: 2px solid ${(props) => (props.active ? "#05d141" : "transparent")};
  margin-bottom: -1px;
  &:hover {
    color: #05d141;
  }
`;

export const MacroGrid = styled.div`
  display: flex;
  justify-content: center;
  gap: 32px;
  margin-bottom: 24px;
`;

export const MacroItem = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const CircleContainer = styled.div`
  position: relative;
  width: 110px;
  height: 110px;
  margin: 0 auto 16px;
`;

export const CircleValue = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 18px;
  font-weight: bold;
  color: #333;
  z-index: 1;
`;

export const MacroLabel = styled.div`
  font-size: .9rem;
  text-transform: uppercase;
  font-weight: 500;
`;

export const MacroInput = styled.input`
  width: 80px;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 6px;
  text-align: center;
  font-size: 1rem;
  background-color: ${(props) => (props.disabled ? "#f5f5f5" : "white")};
  color: ${(props) => (props.disabled ? "#999" : "#333")};
  &:focus {
    outline: none;
    border-color: #1976d2;
  }
`;

export const GramsLabel = styled.span`
  position: absolute;
  right: -22px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 1.25rem;
`;

export const GramsInputContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
`;

export const ErrorBox = styled.div`
  background-color: #ffebee;
  color: #c62828;
  padding: 12px;
  border: 1px solid #ffcdd2;
  border-radius: 8px;
  margin: 2px 0px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
`;

export const ErrorIcon = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #c62828;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 16px;
  flex-shrink: 0;
`;

export const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

